export default "__VITE_ASSET__e2985e75__"